<template>
  <div>
    <CRow>
      <CCol col="12" md="12" lg="12">
        <h4><strong>Data Pelanggaran</strong></h4>
        <hr />
      </CCol>
    </CRow>

    <CRow>
      <CCol col="12" md="12" lg="12">
        <b-button variant="primary" v-b-modal.modal-input-pelanggaran><CIcon name="cil-plus" /> Tambah Data</b-button>
      </CCol>
    </CRow>

    <CRow class="mt-3">
      <CCol col="12" md="12" lg="12">
        <CDataTable :items="items" :fields="fields" responsive sorter hover show-empty :loading="tableBusy">
          <template #actions="{ item }">
            <td>
              <b-button variant="warning" class="mr-1" v-c-tooltip.hover.click="$store.state.table.tooltipEdit" v-b-modal.modal-edit-pelanggaran @click="(dataPelanggaran = item), (edit = !edit)">
                <CIcon name="cil-pencil" />
              </b-button>
              <b-button variant="danger" class="mr-1" v-c-tooltip.hover.click="$store.state.table.tooltipHapus" v-b-modal.modal-delete-pelanggaran @click="dataPelanggaran = item">
                <CIcon name="cil-trash" />
              </b-button>
            </td>
          </template>
        </CDataTable>
      </CCol>
    </CRow>

    <modal-input :data="data" :pelanggaran="pelanggaran" @alertFromChild="triggerAlert($event)" />
    <modal-edit :dataPelanggaran="dataPelanggaran" :pelanggaran="pelanggaran" :edit="edit" @alertFromChild="triggerAlert($event)" />
    <modal-delete :dataPelanggaran="dataPelanggaran" @alertFromChild="triggerAlert($event)" />
  </div>
</template>
<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";
export default {
  props: ["data", "activeTab"],
  components: {
    modalInput,
    modalEdit,
    modalDelete,
  },
  data() {
    return {
      pelanggaran: [],
      dataPelanggaran: [],
      edit: false,
      items: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          sorter: true,
          _classes: "table-number text-center",
        },
        {
          key: "tanggal",
          label: "Tanggal",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
        {
          key: "namaPelanggaran",
          label: "Jenis Pelanggaran",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
        {
          key: "jenisSumberPelanggaran",
          label: "Sumber Pelanggaran",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
        {
          key: "poinPelanggaran",
          label: "Poin",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
        {
          key: "actions",
          label: "Actions",
          _classes: "table-option-3 text-center",
        },
      ],
      tableBusy: false,
    };
  },
  computed: {},
  watch: {
    "data.dataKaryawanId"(newVar, oldVar) {
      if (newVar != oldVar) {
        this.getListPelanggaran();
        this.getPelanggaran();
      }
    },
    activeTab(newVar) {
      if (newVar == 2) {
        this.getListPelanggaran();
        this.getPelanggaran();
      }
    },
  },
  mounted() {},
  methods: {
    async getListPelanggaran() {
      let vm = this;
      let listPelanggaran = await vm.$axios.get("poolPelanggaran/listPoolPelanggaranByKaryawanId/" + vm.$route.query.dataKaryawanId);
      // console.log(listPelanggaran, "ini respon");
      vm.items = listPelanggaran.data.data;
      for (let i = 0; i < vm.items.length; i++) {
        let x = vm.items[i];
        x.no = i + 1;
        x.tanggal = vm.$moment(x.tanggalPelanggaran).format("LL");
      }
    },
    async getPelanggaran() {
      let list = await this.$axios.post("masterPelanggaran/list");
      this.pelanggaran = list.data.data.map((x) => {
        return {
          ...x,
          id: x.masterPelanggaranId,
        };
      });
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getListPelanggaran();
      vm.$emit("change");
    },
  },
};
</script>
